// #region Send

export const hopper1Refill = (data) => window.jsobject.hopper1Refill(data);
export const hopper2Refill = (data) => window.jsobject.hopper2Refill(data);

export const resetUIByIdleTimer = () => window.jsobject.resetUiByIdleTimer();

export const writeLog = (data) => window.jsobject?.writeLog(data);

// #endregion Send
